module.exports = __webpack_public_path__ + "img/vending-no.1dc65eac.svg";